{
  "el": {
    "todo": {
      "actions": {
        "add": "Προσθήκη εργασίας",
        "cancel": "Ακύρωση",
        "delete_todo": "Διαγραφή εργασίας",
        "edit": "Επεξεργασία εργασίας",
        "save": "Αποθήκευση"
      },
      "attributes": {
        "active": "Ενεργή",
        "assignee": "Υπεύθυνος",
        "completed": "Ολοκληρωμένη",
        "description": "Περιγραφή",
        "due_date": "Προθεσμία",
        "title": "Τίτλος"
      },
      "labels": {
        "active": "ενεργή",
        "allDone": "Όλες οι εργασίες έχουν ολοκληρωθεί.",
        "allTodos": "Όλες οι εργασίες",
        "completed": "ολοκληρωμένη",
        "filterTodos": "Φιλτράρισμα εργασιών",
        "filters": "Φίλτρα",
        "myTodos": "Οι εργασίες μου (παλιά έκδοση)",
        "myTodosCount": "Οι εργασίες μου ({count})",
        "noActiveTodos": "Δεν υπάρχουν ενεργές εργασίες",
        "noActiveTodosDashboard": "Συγχαρητήρια, δεν έχεις ανοιχτές εργασίες.",
        "noCompletedYet": "Δεν υπάρχουν ακόμη ολοκληρωμένες εργασίες.",
        "noTodosCustomer": "Ωραία, δεν έχεις ανοιχτές εργασίες.",
        "selectAProjectFirst": "Επίλεξε πρώτα ένα έργο",
        "showLess": "Δείξε λιγότερα",
        "showOthers": "Δείξε περισσότερα | Δείξε περισσότερα ({count})"
      },
      "toasts": {
        "create": "Η εργασία δημιουργήθηκε",
        "delete": "Η εργασία διαγράφηκε",
        "update": "Η εργασία ενημερώθηκε"
      },
      "validation": {
        "needtitle": "Ο τίτλος είναι υποχρεωτικός"
      }
    }
  }
}
